import { render } from "./CustomerDetailsCard.vue?vue&type=template&id=6fa7c286"
import script from "./CustomerDetailsCard.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsCard.vue?vue&type=script&lang=js"

import "../styles/CustomerDetailsCard.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__